import { not, isNil, isEmpty, addIndex, map } from 'ramda'

export const isNotNil = value => not(isNil(value))
export const isNotEmpty = value => not(isEmpty(value))
export const isNotNilOrEmpty = value => isNotNil(value) && isNotEmpty(value)
export const mapIndexed = addIndex(map)
